import Store from '@/store';
import PTC_Pedidos from '@/api/PTC/PTC_Pedidos.client';
import Notifier from '@/libs/Notifier';
import store from '@/store';

export default class PTC_PedidosService {
  constructor() {
    this.client = new PTC_Pedidos();
    this.store = Store;
    this.notify = new Notifier();
  }

  buildQuery(query = {}) {
    const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));

    if (perfilLogado && perfilLogado.perfil_acesso_nome === 'ClienteFinal') {
      const clienteData = JSON.parse(localStorage.getItem('clienteData'));
      if (clienteData && clienteData.cliente && clienteData.cliente.clienteid) {
        query.clienteId = clienteData.cliente.clienteid;
      }
    }

    return query;
  }

  async retornaPedidos(query = {}) {
    try {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', true);
      const queryWithClient = this.buildQuery(query);
      const data = await this.client.retornaPedidos(queryWithClient);
      this.store.commit('PTC_PedidosClient/SET_PEDIDOS', data);
      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
    }
  }

  async retornaPedidoDetalhe(pedidoid) {
    try {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', true);
      const data = await this.client.retornaPedidoDetalhe(pedidoid);
      console.log('pedido', data.pedido[0]);
      this.store.commit('PTC_PedidosClient/SET_DETALHES_PEDIDO', data.pedido[0]);
      this.store.commit('PTC_PedidosClient/ITENS_PEDIDO', data.pedidoItens);
      this.store.commit('PTC_PedidosClient/TOTAL_PEDIDO', data.totalPedido);
      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
    }
  }
}
